export const messages = {
  en: {
    ownerExitRoom: {
      page: {
        title: 'Owner Room Exit',
        subtitle: 'Release the owner-room binding and settle outstanding fees',
        emptyRoom: 'No room selected, please choose an owner first'
      },
      ownerInfo: 'Owner Information',
      name: 'Name',
      idCard: 'ID Card',
      phone: 'Phone',
      ownerRoom: 'Owner Rooms',
      room: 'Room',
      builtUpArea: 'Built-up Area',
      squareMeter: 'Square Meter',
      feeInfo: 'Fee Information',
      feeItem: 'Fee Item',
      arrears: 'Arrears',
      startTime: 'Start Time',
      endTime: 'End Time',
      feeStatus: 'Fee Status',
      validate: {
        ownerRequired: 'Owner is required',
        roomRequired: 'Please select at least one room',
        unpaidFee: 'There are unpaid fees, please handle them first'
      }
    },
    selectFeeConfig: {
      title: 'Create Fee',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      amount: 'Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      amountPlaceholder: 'Required, please enter amount',
      startTimePlaceholder: 'Required, please enter start time',
      endTimePlaceholder: 'Required, please enter end time',
      validate: {
        feeTypeRequired: 'Fee type is required',
        feeItemRequired: 'Fee item is required',
        startTimeRequired: 'Start time is required',
        amountRequired: 'Amount is required'
      }
    }
  },
  zh: {
    ownerExitRoom: {
      page: {
        title: '业主退房',
        subtitle: '解除业主与房屋的绑定关系并结清相关费用',
        emptyRoom: '暂无可退房屋，请先选择业主'
      },
      ownerInfo: '业主信息',
      name: '姓名',
      idCard: '身份证',
      phone: '手机',
      ownerRoom: '业主房屋',
      room: '房屋',
      builtUpArea: '建筑面积',
      squareMeter: '平方米',
      feeInfo: '费用信息',
      feeItem: '费用项目',
      arrears: '欠费',
      startTime: '开始时间',
      endTime: '结束时间',
      feeStatus: '费用状态',
      validate: {
        ownerRequired: '业主不能为空',
        roomRequired: '请至少选择一间房屋',
        unpaidFee: '房屋还存在费用，请先在业务受理处理费用'
      }
    },
    selectFeeConfig: {
      title: '创建费用',
      feeType: '费用类型',
      feeItem: '收费项目',
      amount: '收费金额',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      amountPlaceholder: '必填，请填写收费金额',
      startTimePlaceholder: '必填，请填写计费起始时间',
      endTimePlaceholder: '必填，请填写计费结束时间',
      validate: {
        feeTypeRequired: '费用类型不能为空',
        feeItemRequired: '费用项目不能为空',
        startTimeRequired: '计费起始时间不能为空',
        amountRequired: '收费金额不能为空'
      }
    }
  }
}